import { ColumnDef } from '@tanstack/react-table';
import { DataTable } from '@/components/common/DataTable';
import { DailyRevenue } from '@/types';
import { exportCSV } from '@/utils/exportCSV';
import { dateSortingFn } from '@/utils/date-sort';

export default function DailyRevenueReport() {
  const columns: ColumnDef<DailyRevenue>[] = [
    { accessorKey: 'date', header: 'Date', sortingFn: dateSortingFn },
    {
      accessorKey: 'totalDeposits',
      header: 'Total Deposits',
      cell: ({ row }) => `₹${row.original.totalDeposits}`,
    },
    {
      accessorKey: 'totalWithdrawals',
      header: 'Total Withdrawals',
      cell: ({ row }) => `₹${row.original.totalWithdrawals}`,
    },
    {
      accessorKey: 'totalPayouts',
      header: 'Total Payouts',
      cell: ({ row }) => `₹${row.original.totalPayouts}`,
    },
    {
      accessorKey: 'netRevenue',
      header: 'Net Revenue',
      cell: ({ row }) => `₹${row.original.netRevenue}`,
    },
  ];

  const data: DailyRevenue[] = [
    {
      date: '2025-02-20',
      totalDeposits: 52000,
      totalWithdrawals: 28000,
      totalPayouts: 9000,
      netRevenue: 15000,
    },
    {
      date: '2025-02-21',
      totalDeposits: 46000,
      totalWithdrawals: 30000,
      totalPayouts: 11000,
      netRevenue: 5000,
    },
  ];

  const handleExport = (rows: DailyRevenue[]) => {
    exportCSV({
      filename: 'daily_revenue.csv',
      header: ['Date', 'Total Deposits', 'Total Withdrawals', 'Total Payout', 'Net Revenue'],
      rows: rows.map((r) => [
        r.date,
        r.totalDeposits,
        r.totalWithdrawals,
        r.totalPayouts,
        r.netRevenue,
      ]),
    });
  };

  return (
    <>
      <div className="flex items-center justify-between mb-10">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">Daily Revenue Summary</h2>
          <p className="text-muted-foreground">
            Displays the platform’s daily financial performance including deposits, withdrawals,
            payouts, and overall net revenue.
          </p>
        </div>
      </div>
      <DataTable
        data={data}
        columns={columns}
        enableSelection={true}
        enableExport={true}
        onExport={handleExport}
        searchPlaceholder="Search by date..."
        pageIndex={0}
        total={0}
        onPageChange={function (page: number): void {
          throw new Error('Function not implemented.');
        }}
        onPageSizeChange={function (size: number): void {
          throw new Error('Function not implemented.');
        }}
      />
    </>
  );
}
